String.prototype.formatEx = function () {
    var formatted = this;
    for (var arg in arguments) {
        formatted = formatted.replace("{" + arg + "}", arguments[arg]);
    }
    return formatted;
};

try {
    //tabindex doesnt work on radio/checkboxes
    $('.FormChoice label')
        .attr('tabindex', '0')
        .keydown(function (event) {
            if (event.which == 13 || event.which == 32) {
                $(this).prev('input').first().click();
                event.preventDefault();
                return false;
            }
        })

    // extend the EpiForm JavaScript API in ViewMode
    $.extend(true, epi.EPiServer.Forms, {

        Validators: {
            "Miun.Web.KitModules.Form.Validators.SSNValidator":
                function (fieldName, fieldValue, validatorMetaData) {
                    debugger;
                    //required-validator will handle empty value
                    if (!fieldValue)
                        return true;

                    //is invalid ssn?
                    if (!isValidSSN(fieldValue) || !isValidDate(fieldValue)) {
                        return { isValid: false, message: validatorMetaData.model.additionalAttributes.error_ssn };
                    }

                    if (!isNaN(validatorMetaData.model.additionalAttributes.ssn_minage)) {
                        var birthday = ssnToDate(fieldValue);
                        var minAge = validatorMetaData.model.additionalAttributes.ssn_minage;
                        var age = calculateAge(birthday);

                        return { isValid: age >= minAge, message: validatorMetaData.model.additionalAttributes.ssn_minage_invalid };
                    }
                    else if (!isNaN(validatorMetaData.model.additionalAttributes.ssn_minage_currentyear)) {
                        var birthday = ssnToDate(fieldValue);
                        var minAge = validatorMetaData.model.additionalAttributes.ssn_minage_currentyear;
                        var age = calculateAge(birthday, new Date(new Date().getFullYear(), 11, 31));

                        console.log('ssn_minage_currentyear', minAge, age);

                        return { isValid: age >= minAge, message: validatorMetaData.model.additionalAttributes.ssn_minage_currentyear_invalid };
                    }

                    //all ok!
                    return true;

                    //check if basic requirements are met
                    function isValidSSN(ssn) {
                        var regex = new RegExp(validatorMetaData.model.additionalAttributes.ssn_regex);
                        return regex.test(ssn);
                    }

                    function isValidDate(ssn) {

                        try {
                            return ssnToDate(ssn);
                        }
                        catch (e) {
                            return false;
                        }
                    }

                    //ssn has an actual date (run only on valid ssn!)
                    function ssnToDate(ssn) {

                        if (ssn.length == 10) {

                            //specify century if not included in ssn (applicant can't be over 100 years old... :)) 

                            var yearNow = (new Date().getFullYear() + '').substring(2, 4);
                            var year = ssn.substring(0, 2);

                            ssn =
                                yearNow > year
                                    ? '20' + ssn
                                    : '19' + ssn;
                        }

                        var year = ssn.substring(0, 4);
                        var month = ssn.substring(4, 6);
                        var day = ssn.substring(6, 8);

                        var milliseconds = Date.parse('{0}-{1}-{2}'.formatEx(year, month, day));

                        if (isNaN(milliseconds)) {
                            throw 'badformat';
                        }

                        return new Date(milliseconds);
                    }

                    function calculateAge(birthday, dateNow) { // birthday is a date
                        if (!dateNow) {
                            dateNow = Date.now();
                        }
                        var ageDifMs = dateNow - birthday.getTime();
                        var ageDate = new Date(ageDifMs); // miliseconds from epoch
                        return Math.abs(ageDate.getUTCFullYear() - 1970);
                    }
                },
            "Miun.Web.KitModules.Form.Validators.PasswordValidator":
                function (fieldName, fieldValue, validatorMetaData) {
                    debugger;
                    //required-validator will handle empty value
                    if (!fieldValue)
                        return true;

                    var fieldValueRepeat = $('[name=' + fieldName + '_rpt]').first().val();

                    //is invalid repeat?
                    if (!validatePasswordRpt(fieldValue, fieldValueRepeat)) {
                        return { isValid: false, message: validatorMetaData.model.additionalAttributes.error_repeat };
                    }
                    //is invalid complexity?
                    else if (!validatePasswordComplexity(fieldValue)) {
                        return { isValid: false, message: validatorMetaData.model.additionalAttributes.error_complexity };
                    }

                    //all ok!
                    return { isValid: true };

                    //------------------------------
                    function validatePasswordComplexity(pwd) {
                        var regex = new RegExp(validatorMetaData.model.additionalAttributes.complexity_regex);
                        return regex.test(pwd);
                    }

                    //------------------------------
                    function validatePasswordRpt(pwd1, pwd2) {
                        return pwd1 === pwd2;
                    }
                }
        }
    });
}
catch (e) { }